//import seedrandom from '../lib/seedrandom.esm.js';
import seedrandom from 'seedrandom';

export default class Random {
    constructor(seed) {
        this.random = new seedrandom(seed);
    }
    randomInt(min, max) {
        const range = max - min;
        const value = this.randomDouble();
        return Math.floor(value * range + min);
    }
    randomDouble() {
        const value = this.random.double();
        return value;
    }
    randomDouble2() {
        const value = Math.random();
        return value;
    }
    // getRandomValue() {
    //     try {
    //         if (window) {
    //             let cryptoRandoms, cryptoRandom;
    //             const cryptoRandomSlices = [];
    //             while ((cryptoRandom = "." + cryptoRandomSlices.join("")).length < 30) {
    //                 cryptoRandoms = (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(5));
    //                 for (let i = 0; i < cryptoRandoms.length; i++) {
    //                     const cryptoRandomSlice = cryptoRandoms[i] < 4000000000 ? cryptoRandoms[i].toString().slice(1) : "";
    //                     if (cryptoRandomSlice.length > 0) cryptoRandomSlices[cryptoRandomSlices.length] = cryptoRandomSlice;
    //                 }
    //             }
    //             return Number(cryptoRandom);
    //         }
            
    //         throw "No crypto lib found";
    //     }
    //     catch (e) {
    //         return Math.random();
    //     }
    // }

}